<template>
  <div class="container my-4">
    <div class="card shadow-sm mx-auto text-center p-4" style="max-width: 600px;">
      <img 
        src="@/assets/About/MySoftCode.png" 
        alt="Company Logo" 
        class="img-fluid mb-3" 
        style="max-height: 100px;"
      />
      <h1 class="card-title text-primary mb-3">MySoft Code</h1>
      <p class="card-text fs-5 text-muted">
        Empowering education through innovative and reliable digital solutions.
        Our QR System for tuition classes ensures seamless attendance tracking 
        and efficient classroom management.
      </p>
      <hr />
      <p class="mb-1"><strong>Website:</strong> <a href="https://www.mysoftcode.com" target="_blank">www.mysoftcode.com</a></p>
      <p class="mb-1"><strong>Email:</strong> info@mysoftcode.com</p>
      <p class="mb-0"><strong>Phone:</strong> +94 71 324 6947</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "AboutUs",
};
</script>

<style scoped>
.container {
  padding-top: 10dvh;
}
.card {
  border-radius: 15px;
}
a {
  text-decoration: none;
}
</style>
